
import { setIsMobile } from 'context/reducer/app'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

const useIsMobile = (breakpoint = 600) => {
  const dispatch = useDispatch()
  const [mobile, setMobile] = useState(window.innerWidth < breakpoint)
  useEffect(() => {
    window.addEventListener('resize', async () => {
      setMobile(window.innerWidth < breakpoint)
    })
    return () => {
      window.removeEventListener('resize', async () => {
        setMobile(window.innerWidth < breakpoint)
      })
    }
  }, [breakpoint])
  useEffect(() => {
    dispatch(setIsMobile(mobile))
  }, [mobile, dispatch])
}

export default useIsMobile
